module.exports = __webpack_public_path__ + "card.3896e07af39de1f8f4925a5cb3ad76e3.svg";